import { useCallback, useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import ExtUserPaymentHistoryService from "../../../../services/accounts/externalUserPaymentHistory";

export const useFetchData = (accountNumber: number, year: number) => {
  const navigate: NavigateFunction = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data, setData] = useState<any[]>([]);

  const fetchData = useCallback(
    async (year: number | undefined) => {
      setIsLoading(true);
      try {
        const res = await ExtUserPaymentHistoryService.fetchAll({
          contractNumber: accountNumber,
          yearFrom: year,
          yearTo: year,
          pageNumber: 1,
          pageSize: 10000,
        });

        setData(res);

        setIsLoading(false);
      } catch (e: any) {
        const data = e.response.data;
        data.status === 400 && navigate("/not-found");
        setIsLoading(false);
      }
    },
    [accountNumber, navigate, setData, setIsLoading],
  );

  useEffect(() => {
    if (year) {
      fetchData(year);
    }
  }, [fetchData, year]);

  return { data, isLoading };
};
